import axios from "axios";

export async function subirArchivo(archivo) {
  try {
    // Validar tamaño antes de enviar
    const maxSize = 5 * 1024 * 1024;
    if (archivo.size > maxSize) {
      throw new Error("El archivo es demasiado grande. Máximo 10MB permitido.");
    }

    const formData = new FormData();
    formData.append("file", archivo);

    const extension = archivo.name.split(".").pop();
    const nombreSinExtension = archivo.name.replace(`.${extension}`, "");

    const nuevoNombre = `${nombreSinExtension}_${Math.random()
      .toString(36)
      .substring(7)}.${extension}`;

    formData.append("nombre", nuevoNombre);

    const response = await axios.post("/api/archivos/", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      timeout: 30000, // 30 segundos de timeout
    });

    if (response.status === 200) {
      return response.data.name || nuevoNombre;
    } else {
      return null;
    }
  } catch (error) {
    console.error("Error subiendo archivo:", error);

    // Manejar diferentes tipos de errores
    if (error.response?.status === 413) {
      throw new Error("El archivo es demasiado grande para el servidor.");
    } else if (error.message.includes("timeout")) {
      throw new Error(
        "El archivo tardó demasiado en subirse. Intenta con un archivo más pequeño."
      );
    } else {
      throw new Error("Error al subir el archivo. Intenta de nuevo.");
    }
  }
}
